"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageResult = void 0;
const builder_1 = require("./builder");
class PageResult {
    total;
    pageSize;
    current;
    data;
    static build(pagination, type) {
        const { list, ...info } = pagination;
        if (type) {
            return (0, builder_1.builder)(PageResult, {
                ...info,
                data: list?.map((item) => (0, builder_1.builder)(type, item).build()) || [],
            }).build();
        }
        return (0, builder_1.builder)(PageResult, { ...info, data: list }).build();
    }
    get hasMore() {
        return this.pageSize * this.current < this.total;
    }
    get hasPagination() {
        return this.pageSize < this.total;
    }
    get first() {
        return 1;
    }
    get prev() {
        if (this.current === 1) {
            return 1;
        }
        return this.current - 1;
    }
    get next() {
        if (this.hasMore) {
            return (this.current += 1);
        }
        return this.current;
    }
    get last() {
        return Math.ceil(this.total / this.pageSize);
    }
}
exports.PageResult = PageResult;
//# sourceMappingURL=page.js.map